/* tslint:disable */
/* eslint-disable */
/**
 * SR AAT specification
 * Description
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Explicit Agency Workspace platform access. DESKTOP_ONLY disables web access and clears the desktop block. WEB_ONLY enables web access and the Desktop_Disabled role. DESKTOP_WEB enables web access and clears the desktop block. When applicationType is supplied, application settings are replaced on create and update, and omitting platformAccess removes platform overrides. An empty applicationType clears application settings. A null or omitted applicationType leaves application settings unchanged.

 * @export
 */
export const PlatformAccess = {
    DesktopOnly: 'DESKTOP_ONLY',
    WebOnly: 'WEB_ONLY',
    DesktopWeb: 'DESKTOP_WEB'
} as const;
export type PlatformAccess = typeof PlatformAccess[keyof typeof PlatformAccess];


export function PlatformAccessFromJSON(json: any): PlatformAccess {
    return PlatformAccessFromJSONTyped(json, false);
}

export function PlatformAccessFromJSONTyped(json: any, ignoreDiscriminator: boolean): PlatformAccess {
    return json as PlatformAccess;
}

export function PlatformAccessToJSON(value?: PlatformAccess | null): any {
    return value as any;
}

